import React, { useState } from 'react'
import { Drawer, IconButton, List, ListItemButton, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';

const PAGES = ["Home", "About", "Services", "Contact"]

const DrawerComp = () => {
  const [openDrawer, setopenDrawer] = useState(false)

  return (
    <React.Fragment>
      <Drawer
        anchor='right'
        open={openDrawer}
        onClose={() => setopenDrawer(false)}
        sx={{
          '& .MuiDrawer-paper': {
            width: {
              xs: '66.666%', // 2/3 of the screen width for extra small screens
              sm: '300px'    // Default width for larger screens
            },
            backgroundColor: '#e6e4df', // Light gray background
            fontFamily: 'Roboto, Arial, sans-serif', // Custom font
            fontweight:900
          }
        }}
      >
        <List sx={{
          backgroundColor: '#e6e4df',
          height: '100%'
        }}>
          {
            PAGES.map((page, index) => (
              <ListItemButton
                key={index}
                component={Link}
                to={page === 'Home' ? '/' : `/${page.toLowerCase()}`}
                onClick={() => setopenDrawer(false)}
                sx={{
                  '&:hover': {
                    backgroundColor: '#e0e0e0' // Slightly darker on hover
                  }
                }}
              >
                <ListItemText
                  primary={page}
                  primaryTypographyProps={{
                    sx: {
                      fontFamily: 'Roboto, Arial, sans-serif',
                      color: 'black', // Dark gray text
                      fontWeight: 500, // Slightly bolder text
                    fontSize:'2.2rem'
                    }
                  }}
                />
              </ListItemButton>
            ))
          }
        </List>
      </Drawer>
      <IconButton
        sx={{
          color: 'black',
          marginLeft: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.1)', // Light transparent background
          borderRadius: '8px', // Slightly rounded edges
          padding: '10px',
          transition: 'all 0.3s ease-in-out',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.2)', // Darker on hover
            transform: 'scale(1.1)', // Slight zoom effect
          }
        }}
        onClick={() => setopenDrawer(!openDrawer)}
      >
        <MenuIcon sx={{ fontSize: '2rem' }} />
      </IconButton>
    </React.Fragment>
  )
}

export default DrawerComp